"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeContracts = void 0;
var mergeContracts = function () {
    var contracts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        contracts[_i] = arguments[_i];
    }
    var mergedContract = { accepted: [], emitted: [] };
    contracts.forEach(function (_a) {
        var accepted = _a.accepted, emitted = _a.emitted;
        accepted.forEach(function (action) {
            var isNew = !mergedContract.accepted.includes(action) && !mergedContract.accepted.find(function (_a) {
                var type = _a.type;
                return type === action.type;
            });
            if (isNew)
                mergedContract.accepted.push(action);
        });
        emitted.forEach(function (action) {
            var isNew = !mergedContract.emitted.includes(action) && !mergedContract.emitted.find(function (_a) {
                var type = _a.type;
                return type === action.type;
            });
            if (isNew)
                mergedContract.emitted.push(action);
        });
    });
    return mergedContract;
};
exports.mergeContracts = mergeContracts;
